'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ramdaExtra = require('@solta/ramda-extra');
var awsAmplify = require('aws-amplify');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["success"] = "success";
    ResponseStatus["error"] = "error";
})(ResponseStatus || (ResponseStatus = {}));
var ResponseStatus$1 = ResponseStatus;

var successResponse = function (data) { return ({
    status: ResponseStatus$1.success,
    data: data,
}); };
var errorResponse = function (message) { return ({
    status: ResponseStatus$1.error,
    error: { message: message },
}); };

var AuthSdk = /** @class */ (function () {
    function AuthSdk() {
        this.callbacks = {
            tokenChange: [],
            signUp: [],
            confirmSignUp: [],
        };
    }
    AuthSdk.prototype.configure = function (config) {
        var _this = this;
        var result = awsAmplify.Amplify.configure(config);
        awsAmplify.Hub.listen('auth', function () {
            _this.getCurrentSession().then(function (newSession) {
                var _a;
                if ((newSession === null || newSession === void 0 ? void 0 : newSession.accessToken.jwtToken) !== ((_a = _this.currentSession) === null || _a === void 0 ? void 0 : _a.accessToken.jwtToken)) {
                    _this.currentSession = newSession;
                    _this.callbacks.tokenChange.forEach(function (callback) {
                        callback(_this.currentSession);
                    });
                }
            });
        });
        awsAmplify.Hub.listen('newUser', function (_a) {
            var payload = _a.payload;
            var event = payload.event, data = payload.data;
            ramdaExtra.forEachObjIndexed(function (listenedEventCallbacks, listenedEvent) {
                if (ramdaExtra.isEmpty(listenedEventCallbacks)) {
                    return;
                }
                if (event === listenedEvent) {
                    listenedEventCallbacks.forEach(function (callback) {
                        callback(data);
                    });
                }
            }, _this.callbacks);
        });
        return ramdaExtra.isNilOrEmpty(result)
            ? errorResponse('Failed to configure authentication service')
            : successResponse(result);
    };
    AuthSdk.prototype.getCurrentCredentials = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, awsAmplify.Auth.currentCredentials()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthSdk.prototype.getCurrentSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, awsAmplify.Auth.currentSession()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // eslint-disable-next-line complexity
    AuthSdk.prototype.signIn = function (_a) {
        var email = _a.email, password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            var result, error_3, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, awsAmplify.Auth.signIn(email, password)];
                    case 1:
                        result = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _b.sent();
                        switch (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) {
                            case 'Incorrect username or password.':
                                return [2 /*return*/, errorResponse('Incorrect username or password')];
                            case 'Password attempts exceeded':
                                return [2 /*return*/, errorResponse(error_3 === null || error_3 === void 0 ? void 0 : error_3.message)];
                            default:
                                return [2 /*return*/, errorResponse('Failed to sign in')];
                        }
                    case 3:
                        if (ramdaExtra.isNilOrEmpty(result))
                            return [2 /*return*/, errorResponse('Failed to sign in')];
                        data = {
                            externalId: ramdaExtra.path(['attributes', 'sub'], result),
                            email: ramdaExtra.path(['attributes', 'email'], result),
                            tokens: {
                                accessToken: ramdaExtra.path(['signInUserSession', 'accessToken', 'jwtToken'], result),
                                refreshToken: ramdaExtra.path(['signInUserSession', 'refreshToken', 'token'], result),
                                idToken: ramdaExtra.path(['signInUserSession', 'idToken', 'jwtToken'], result),
                            },
                        };
                        return [2 /*return*/, successResponse(data)];
                }
            });
        });
    };
    AuthSdk.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, awsAmplify.Auth.signOut()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, successResponse({})];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, errorResponse('Failed to sign out')];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthSdk.prototype.getUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, awsAmplify.Auth.currentAuthenticatedUser()];
                    case 1:
                        result = _a.sent();
                        data = {
                            externalId: ramdaExtra.path(['attributes', 'sub'], result),
                            email: ramdaExtra.path(['attributes', 'email'], result),
                            emailVerified: ramdaExtra.path(['attributes', 'email_verified'], result),
                            tokens: {
                                accessToken: ramdaExtra.path(['signInUserSession', 'accessToken', 'jwtToken'], result),
                                refreshToken: ramdaExtra.path(['signInUserSession', 'refreshToken', 'token'], result),
                                idToken: ramdaExtra.path(['signInUserSession', 'idToken', 'jwtToken'], result),
                            },
                            attributes: result.attributes,
                        };
                        return [2 /*return*/, successResponse(data)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, errorResponse('Failed to get user info')];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthSdk.prototype.getFullUserDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, awsAmplify.Auth.currentAuthenticatedUser()];
            });
        });
    };
    AuthSdk.prototype.on = function (event, callback) {
        var _this = this;
        this.callbacks[event].push(callback);
        return function () {
            _this.callbacks[event] = _this.callbacks[event].filter(function (c) { return c !== callback; });
        };
    };
    AuthSdk.prototype.setupTOTP = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var code;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, awsAmplify.Auth.setupTOTP(user)];
                    case 1:
                        code = _a.sent();
                        return [2 /*return*/, code];
                }
            });
        });
    };
    AuthSdk.prototype.verifyTOTPSetup = function (user, challengeCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, awsAmplify.Auth.verifyTotpToken(user, challengeCode)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, awsAmplify.Auth.setPreferredMFA(user, 'TOTP')];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, errorResponse('Failed to verify Challenge Code')];
                    case 4: return [2 /*return*/, successResponse('Successfully verified')];
                }
            });
        });
    };
    /**
     * Step one in the Change Password flow. When invoked will send the user a verification code via email by default.
     * @param username The username provided by the service provider, in a uuid format
     * @returns successResponse: { status, data}
     */
    AuthSdk.prototype.getChangePasswordCode = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            var error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, awsAmplify.Auth.forgotPassword(username)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_7 = _a.sent();
                        return [2 /*return*/, errorResponse(error_7 === null || error_7 === void 0 ? void 0 : error_7.message)];
                    case 3: return [2 /*return*/, successResponse('Password change verification code sent successfully')];
                }
            });
        });
    };
    /**
     * Step two in the Change Password flow. Updates the User's password.
     * @param username The username provided by the service provider, in a uuid format
     * @param code Verification code provided to user
     * @param newPassword The intended new password provided by the user
     * @returns successResponse: { status, data}
     */
    AuthSdk.prototype.changePassword = function (username, code, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, awsAmplify.Auth.forgotPasswordSubmit(username, code, newPassword)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_8 = _a.sent();
                        switch (error_8 === null || error_8 === void 0 ? void 0 : error_8.message) {
                            case 'Invalid code provided, please request a code again.':
                                return [2 /*return*/, errorResponse('Invalid code provided, please request a code again')];
                            case 'Attempt limit exceeded, please try after some time.':
                                return [2 /*return*/, errorResponse('Attempt limit exceeded, please try after some time')];
                            default:
                                return [2 /*return*/, errorResponse('Failed to change password')];
                        }
                    case 3: return [2 /*return*/, successResponse('Successfully changed password')];
                }
            });
        });
    };
    return AuthSdk;
}());
var AuthSdkInstance = new AuthSdk();

exports.AuthSdk = AuthSdkInstance;
